import type { ConnectionTestResult, FtpAccount, FtpSettings, ftpSettingsInputSchema } from '@flux/shared';
import type { z } from 'zod';
import { apiFetch } from '@/lib/api/client.js';

/**
 * `FtpSettingsInput` n'est pas exporté comme type par `@flux/shared` (seul le
 * schéma `ftpSettingsInputSchema` l'est) — dérivé ici par `z.infer` plutôt que
 * de retoucher le paquet partagé (hors périmètre de cette vague).
 */
export type FtpSettingsInput = z.infer<typeof ftpSettingsInputSchema>;

/** Onglet Martelet FTP (`02` §12.3). */
export function fetchFtpSettings(): Promise<FtpSettings> {
  return apiFetch<FtpSettings>('/api/settings/ftp');
}

export function updateFtpSettings(body: FtpSettingsInput): Promise<FtpSettings> {
  return apiFetch<FtpSettings>('/api/settings/ftp', { method: 'PUT', body });
}

export function testFtpConnection(account: FtpAccount): Promise<ConnectionTestResult> {
  return apiFetch<ConnectionTestResult>('/api/settings/ftp/test', { method: 'POST', body: { account } });
}
